export const normalize = value => (value ?? '').trim().toLowerCase().replace(/\s+/g, ' ');

export const normalizeGender = value => {
    const normalizedValue = normalize(value);

    if (['m', 'male'].includes(normalizedValue)) return 'male';
    if (['w', 'f', 'female'].includes(normalizedValue)) return 'female';
    if (['u', 'unknown'].includes(normalizedValue)) return 'unknown';
    return normalizedValue;
};

// Normalise profession values so HCPC dataset professions can be compared
// safely against staff-role values from the form.
export const normalizeProfession = value => normalize(value);

export const validateHcpcRecord = (
    record,
    enteredDetails,
    { skipHcpcPersonValidation = false } = {}
) => {
    if (!record) {
        return { accepted: false, reason: 'No record selected' };
    }

    const enteredProfession = normalizeProfession(enteredDetails?.profession);
    const recordProfession = normalizeProfession(record?.Profession);

    // Profession must still be checked when available, even where name/gender
    // validation is skipped for pooled collections.
    const shouldCheckProfession = enteredProfession && recordProfession;

    if (shouldCheckProfession && enteredProfession !== recordProfession) {
        return { accepted: false, reason: 'Profession does not match HCPC record' };
    }

    if (skipHcpcPersonValidation) {
        return { accepted: true, reason: null };
    }

    const firstMatch = normalize(enteredDetails?.firstName) === normalize(record.First_Name);
    const surnameMatch = normalize(enteredDetails?.surname) === normalize(record.Last_Name);

    let genderMatch = true;

    const enteredGender = normalizeGender(enteredDetails?.gender);
    const recordGender = normalizeGender(record?.Gender);

    const shouldCheckGender = enteredGender && enteredGender !== 'unknown' && recordGender;

    if (shouldCheckGender) {
        genderMatch = enteredGender === recordGender;
    }

    if (!firstMatch) {
        return { accepted: false, reason: 'First name does not match HCPC record' };
    }

    if (!surnameMatch) {
        return { accepted: false, reason: 'Surname does not match HCPC record' };
    }

    if (!genderMatch) {
        return { accepted: false, reason: 'Gender does not match HCPC record' };
    }

    return { accepted: true, reason: null };
};
